<template>
    <div class="OrderListTable">
        <el-table :data="tableData" style="width: 100%">
            <!-- <el-table-column type="index" :index="indexMethod" label="序号" width="100" align='center'></el-table-column> -->
            <el-table-column property="index" width="100" label="序号" align='center'></el-table-column>
            <el-table-column property="orderno" label="订单号" align='center'></el-table-column>
            <el-table-column property="productname" label="商品名称" align='center'>
                <template slot-scope="scope">
                    <div class="goods_list_box">
                        <div v-for="(item, index) in scope.row.productlist" :key="index" class="goods_name_box">
                            <span>{{item.productname}}</span>
                            <span>{{'×' + item.productcount}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column property="orderprice" label="订单金额" align='center'></el-table-column>
            <el-table-column property="ordertime" label="订单时间" align='center'></el-table-column>
            <el-table-column label="订单状态" align='center'>
                <template slot-scope="scope">
                    <span :class="statusClass(scope.row.orderstatustext)">{{scope.row.orderstatustext}}</span>
                </template>
            </el-table-column>
            <el-table-column property="checktime" label="核销时间" align='center'></el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="findOrderList"></page>
    </div>
</template>

<script>
import Page from 'base/page/page'
import {getUserEventOrderList} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: "OrderListTable",
    props: ['orderListData'],
    data() {
        return {
            total: 0,
            tableData: []
        }
    },
    mounted() {},
    methods: {
        // 自定义索引
        indexMethod(index) {
            if (this.page.page > 1) {
                if (index < 9) {
                    return `${this.page.page - 1}${index + 1}`
                } else {
                    return `${this.page.page}0`
                }
            } else {
                return index + 1
            }
        },
        // 查询用户详情下订单列表
        findOrderList() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.innerid,
                assinnerid: this.$route.query.assinnerid,
            }
            getUserEventOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        statusClass(value) {
            if (value === '待支付' || value === '待核销') {
                return 'dzf'
            } else if (value === '已完成' || value === '已核销') {
                return 'ywc'
            } else if (value === '已取消') {
                return 'yqx'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        orderListData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log(this.orderListData)
                this.tableData = this.orderListData.content
                this.total = this.orderListData.pageinfo.rowCount
                
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
    .OrderListTable{
        .ywc {
            color: #67C23A;
        }
        .dzf {
            color: #E6A23C;
        }
        .yqx {
            color: #606266;
        }
        .goods_list_box{
            min-height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .goods_name_box{
                &>span:nth-of-type(2){
                    margin-left: 10px;
                    color: #909399;
                }
            }
        }
    }
</style>